var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11323",
    "data-name": "Path 11323",
    d: "M28.179,25.28H20.61V24.126h7.569l.842-4.39-.04-.052H20.61V18.53h8.371a1.183,1.183,0,0,1,.917.433,1.2,1.2,0,0,1,.26.992l-.8,4.35a1.194,1.194,0,0,1-1.177.975Z",
    transform: "translate(-8.72 -7.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11324",
    "data-name": "Path 11324",
    d: "M25.5,26.863H18.518a1.206,1.206,0,0,1-1.154-.894l-2.25-8.406-2.054-.029V16.38h2.013a1.194,1.194,0,0,1,1.154.888l2.244,8.406,7.033.035Z",
    transform: "translate(-5.525 -6.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3814",
    "data-name": "Rectangle 3814",
    width: 1.246,
    height: 1.154,
    transform: "translate(11.89 20.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3815",
    "data-name": "Rectangle 3815",
    width: 1.246,
    height: 1.154,
    transform: "translate(18.733 20.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11325",
    "data-name": "Path 11325",
    d: "M44.36,27.925l-2.89-2.9.813-.819,2.077,2.083,2.083-2.083.813.819Z",
    transform: "translate(-17.545 -10.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11326",
    "data-name": "Path 11326",
    d: "M5.473,25.065,3.4,22.983,1.313,25.065.5,24.246l2.9-2.9,2.9,2.9Z",
    transform: "translate(-0.212 -9.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11327",
    "data-name": "Path 11327",
    d: "M16.912,37.026A12.4,12.4,0,0,1,4.52,24.633V22.77H5.674v1.863a11.244,11.244,0,0,0,21.888,3.606l1.09.375A12.381,12.381,0,0,1,16.912,37.026Z",
    transform: "translate(-1.912 -9.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11328",
    "data-name": "Path 11328",
    d: "M29.783,18.764H28.629V16.9A11.244,11.244,0,0,0,6.74,13.3L5.65,12.92A12.392,12.392,0,0,1,29.783,16.9Z",
    transform: "translate(-2.39 -1.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3816",
    "data-name": "Rectangle 3816",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionActive);
export default __webpack_public_path__ + "static/media/subscription-active.5eff1b78a4a2a85260dc4f087484e4be.svg";
export { ForwardRef as ReactComponent };